import { combineReducers } from "redux";
import authReducer from "./authReducer";
import cardReducer from "../../modules/card/model/cardReducer";
import LeadDataReducer from "./new/leadDataReducer";
import SubscriptionReducer from "./new/subscriptionListReducer";
import SubsPackageReducer from "./new/subsPackageReducer";
import notificationDataReducer from "./new/notificationReducer";
import connectionReducer from "./new/connectionReducer";
import businessReducer from "./new/businessReducer";
import galleryReducer from "./new/galleryReducer";
import userReducer from "./new/userReducer";
import StoreDataReducer from "./new/storeReducer";

const rootReducer = combineReducers({
	auth: authReducer,
	cardData: cardReducer,
	userData: userReducer,
	subscriptionData: SubscriptionReducer,
	subscriptionPackage: SubsPackageReducer,
	leadDataReducer: LeadDataReducer,
	notificationData: notificationDataReducer,
	connectionAllData: connectionReducer,
	businessAllData: businessReducer,
	galleryAllData: galleryReducer,
	storeData: StoreDataReducer,
});
export default rootReducer;
